import Editor from "./TextEditor/Editor";

function ArticleCreater(props) {
	return (
		<>
			<Editor
				setOpenEditor={props.setOpenEditor}
				color={props.color}
				fontmultiplier={props.fontMultiplier}
				content={props.content}
				currentContentId={props.currentContentId}
				mode={props.mode}
				setErrorDialog={props.setErrorDialog}
				links={props.links}
			/>
		</>
	);
}

export default ArticleCreater;
